export const rules = {
  EQUAL: "=",
  GREATER_THAN: ">",
  GREATER_THAN_EQUAL: ">=",
  LESS_THAN: "<",
  LESS_THAN_EQUAL: "<=",
};

export const rulesList = Object.keys(rules).map((rule) => ({
  value: rule,
  text: rules[rule],
  label: rules[rule],
}));
